<template>
	<div class="product-new">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<ValidationError :errors="errors" />
			<ProductForm
				:product="product"
				:name.sync="product.name"
				:product_code.sync="product.product_code"
				:cost_price.sync="product.cost_price"
				:standard_price.sync="product.standard_price"
				:list_price.sync="product.list_price"
				:specification.sync="product.specification"
				:wildcard.sync="product.wildcard"
				:product_category_id.sync="product.product_category_id"
				:product_sub_category_id.sync="product.product_sub_category_id"
				:product_code_prefix_id.sync="product.product_code_prefix_id"
				:action="action"
			>
				<template v-slot:submit-btn>
					<v-row no-gutters class="mt-4" justify="center">
						<v-btn color="secondary" :disabled="!isValid" @click="createProduct"> 登録する </v-btn>
					</v-row>
				</template>
			</ProductForm>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import ProductForm from "./ProductForm.vue"
import ValidationError from "../shared/ValidationError.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		ProductForm,
		ValidationError,
	},
	data() {
		return {
			mainTitle: "製品",
			title: "製品作成",
			action: "new",
			product: {
				name: "",
				product_code: "",
				cost_price: "",
				standard_price: "",
				list_price: "",
				specification: "",
				wildcard: true,
				categories: [],
				product_category_id: "",
				product_sub_category_id: "",
				product_code_prefixes: [],
				product_code_prefix_id: "",
				persistent_hint: true,
				statuses: [],
			},
			errors: [],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchCategories()
	},
	methods: {
		fetchCategories() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/products/new", { headers })
				.then((res) => {
					this.product.categories = res.data.categories
					this.product.product_code_prefixes = res.data.prefixes
					this.product.statuses = res.data.statuses
				})
				.catch((err) => {
					if (err.response?.status == 400) {
						this.errors = err.response.data?.errors
					}
					errorHandling.errorResponse(err)
				})
		},
		createProduct() {
			const headers = authenticate.setHeader()
			axios
				.post(
					"/erp/v1/products",
					{
						product: {
							name: this.product.name,
							product_code: this.product.product_code,
							standard_price: this.product.standard_price,
							list_price: this.product.list_price,
							cost_price: this.product.cost_price,
							specification: this.product.specification,
							product_category_id: this.product.product_category_id,
							product_sub_category_id: this.product.product_sub_category_id,
							wildcard: this.product.wildcard,
							product_code_prefix_id: this.product.product_code_prefix_id,
							status: this.product.status_number,
						},
					},
					{
						headers,
					}
				)
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "製品を登録しました。",
					})
					this.$router.push({ name: "product_index" })
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
	},
	computed: {
		isValid() {
			if (
				this.isPresence(this.product.name) &&
				this.isPresence(this.product.product_category_id) &&
				this.isPresence(this.product.product_sub_category_id) &&
				this.isPresence(this.product.product_code_prefix_id)
			) {
				return true
			} else {
				return false
			}
		},
	},
}
</script>
